import { $t } from '@/i18n';
import { postEmail, notifyByWework } from './notification';
import { robotApi } from '@/services';
import { isEmpty } from 'lodash';
import { message } from '@utils/wuji-message';
import {
  XyRtxSelectorMeta,
  XyRobotSelectorMeta,
  XyWeworkMessageMeta,
  XyWxworkSelectorMeta,
  XyEmailSelectorMeta,
} from '../paramsFormComponents';
import { CATEGORY } from './const';
import stringInterop from '@tencent/ui-core/lib/utils/stringInterop';
import { ENABLE_EMAIL_SETTING, HAS_EMAIL_SERVICE } from '@/config/constant';

// 邮件通知
export const emailNotificationAtom = {
  id: 'xy:source:emailNotification',
  name: $t('k_7fd7aa57'),
  category: CATEGORY.NOTIFICATION,
  paramsSchema: {
    type: 'object',
    fields: [
      ...(ENABLE_EMAIL_SETTING ? [
        {
          id: 'emailId',
          type: 'string',
          title: $t('k_aeeddca'),
          default: '',
          ui: { type: 'XyEmailSelector' },
        },
      ] : []),
      {
        id: 'to',
        type: 'string',
        title: $t('k_f9ea78a5'),
        default: '',
        ui: { type: 'XyRtxSelector' },
      },
      {
        id: 'cc',
        type: 'string',
        title: $t('k_902196d0'),
        default: '',
        ui: { type: 'XyRtxSelector' },
      },
      {
        id: 'bcc',
        type: 'string',
        title: $t('k_9e1be7d3'),
        default: '',
        ui: { type: 'XyRtxSelector' },
      },
      {
        id: 'title',
        type: 'string',
        title: $t('k_646011a0'),
        default: '',
      },
      {
        id: 'content',
        type: 'string',
        title: $t('k_2a5af184'),
        default: '',
      },
    ],
  },
  paramsFormComponents: [
    XyRtxSelectorMeta,
    XyEmailSelectorMeta,
  ],
  async execute(ctx, params) {
    const { to, cc = '', bcc = '', title, content, emailId = '' } = params;
    if (!to || !title || !content) {
      throw new Error($t('k_950eed59'));
    }

    await postEmail(to, title, content, { cc, bcc, emailId });
  },
};
// 企微机器人通知
export const robotNotificationAtom = {
  id: 'xy:source:robotNotification',
  name: $t('k_74a14ee8'),
  category: CATEGORY.NOTIFICATION,
  desc: $t('k_df6b2766'),
  paramsSchema: {
    type: 'object',
    fields: [
      {
        id: 'robotId',
        type: 'string',
        title: $t('k_6b0143be'),
        ui: { type: 'XyRobotSelector' },
      },
      {
        id: 'data',
        type: 'string',
        title: $t('k_452499c5'),
        description: '',
        default: JSON.stringify({ msgtype: 'text', text: { content: 'hello {{w.user.userId}}' } }, null, 2),
      },
      {
        id: 'successNotice',
        type: 'boolean',
        title: $t('k_d212955'),
        default: true,
      },
    ],
  },
  async execute(ctx, params) {
    const { projectId, env } = window.w;
    const { robotId, successNotice } = params;
    if (!robotId || !params.data) {
      const msg = $t('k_ce9f22e9');
      throw new Error(msg);
    }
    let data = null;
    try {
      if (typeof params.data === 'string') data = JSON.parse(params.data);
      else data = params.data;
    } catch (error) {
      const msg = $t('k_f61dfa4a');
      throw new Error(msg);
    }
    try {
      await robotApi.postRobotMessage(projectId, env, robotId, data);
      successNotice && message.success($t('k_858a290e'));
    } catch (error) {
      const msg = $t('k_78a10542');
      throw new Error(msg);
    }
  },
  paramsFormComponents: [
    XyRobotSelectorMeta,
  ],
};
// 企业微信通知
export const weworkNotificationAtom = {
  id: 'xy:source:weworkNotification',
  name: $t('k_781e2f73'),
  category: CATEGORY.NOTIFICATION,
  paramsSchema: {
    type: 'object',
    fields: [
      {
        id: 'weworkMsgConfig',
        type: 'object',
        title: $t('k_f34627de'),
        'uc:allowInterop': true,
        ui: { type: 'XyWeworkMessage' },
        fields: [
          {
            id: 'weworkApp',
            title: $t('k_41e79eab'),
            type: 'string',
            default: '',
          },
          {
            id: 'receiverType',
            title: $t('k_fdbedf8'),
            type: 'string',
            default: 'dynamic',
          },
          {
            id: 'receivers',
            title: $t('k_8bb652da'),
            type: 'string',
            default: '',
          },
          {
            id: 'msgType',
            title: $t('k_ff841d1f'),
            type: 'string',
            default: 'text',
          },
          {
            id: 'content',
            title: $t('k_7454f20'),
            type: 'string',
            default: '',
          },
          {
            id: 'title',
            title: $t('k_8bdba086'),
            type: 'string',
            default: '',
          },
          {
            id: 'description',
            title: $t('k_7454f20'),
            type: 'string',
            default: '',
          },
          {
            id: 'url',
            title: $t('k_d663218e'),
            type: 'string',
            default: '',
          },
          {
            id: 'btnTxt',
            title: $t('k_9c4c9dc'),
            type: 'string',
            default: $t('k_64babb9a'),
          },
        ],
      },
    ],
  },
  paramsFormComponents: [
    XyWeworkMessageMeta,
  ],
  async execute(ctx, params) {
    const {
      weworkApp,
      receivers, msgType, content, title, description, url, btnTxt } = params.weworkMsgConfig || {};
    if (isEmpty(receivers)) {
      throw new Error($t('k_ca02b77d'));
    }
    if (msgType === 'text') {
      if (!content) {
        throw new Error($t('k_20ded012'));
      }
    } else if (msgType === 'markdown') {
      if (!content) {
        throw new Error($t('k_acf52c6b'));
      }
    } else {
      if (!title || !description || !url || !btnTxt) {
        throw new Error($t('k_edaaf97e'));
      }
    }

    const receiverList = typeof receivers === 'string' ? receivers.split(/[ ,;]/g).filter(Boolean) : receivers;
    const data = { receivers: receiverList, msgType };
    data.data = ['text', 'markdown'].includes(msgType) ? { content } : { title, description, url, btntxt: btnTxt };
    const { projectId, env } = window.w;

    const builtin = weworkApp === 'builtin';
    await notifyByWework(projectId, env, data, builtin);
    message.success($t('k_1ec66a3b'));
  },
};
// 唤起企业微信
export const messageAtom = {
  id: 'xyEvent:wxwork:message',
  name: $t('k_c3e7de2c'),
  category: CATEGORY.NOTIFICATION,
  paramsSchema: {
    type: 'object',
    fields: [
      {
        id: 'messageConfig',
        title: $t('k_d700b76b'),
        type: 'object',
        ui: { type: 'XyWxworkSelector' },
        fields: [
          {
            id: 'type',
            title: $t('k_9ff5ee55'),
            type: 'string',
            default: 'username',
          },
          {
            id: 'username',
            title: $t('k_9b026908'),
            type: 'string',
            default: '',
          },
          {
            id: 'usernameExpr',
            title: $t('k_8e926d67'),
            type: 'string',
            default: '',
          },
          {
            id: 'uin',
            title: $t('k_d7d9aaf'),
            type: 'string',
            default: '',
          },
        ],
      },
    ],
  },
  paramsFormComponents: [
    XyWxworkSelectorMeta,
  ],
  async execute(ctx, params) {
    const { type, username, usernameExpr, uin } = (params?.messageConfig ?? {});
    let typeValue;
    if (type === 'username') {
      typeValue = username;
      if (!username) {
        throw new Error($t('k_f72d031f'));
      }
    }
    if (type === 'usernameExpr') {
      typeValue = stringInterop(usernameExpr, ctx.renderer);
      if (!typeValue) {
        throw new Error($t('k_f72d031f'));
      }
    }
    if (type === 'uin') {
      typeValue = stringInterop(uin, ctx.renderer);
      if (!typeValue) {
        throw new Error($t('k_93e4c99f'));
      }
    }
    if (typeValue) {
      typeValue = String(typeValue).replace(/\s*[，；、,]\s*/g, ';')
        .trim();
      const openType = type === 'usernameExpr' ? 'username' : type;
      window.open(`wxwork://message.com/?${openType}=${typeValue}`, '_blank');
    };
  },
};

export default [
  ...(HAS_EMAIL_SERVICE ? [emailNotificationAtom] : []),
  robotNotificationAtom,
  weworkNotificationAtom,
  messageAtom,
];
